import Vue from 'vue';

Vue.filter('sex', function(value) {
    if (!value) return '';
    let newValue = '';
    switch (value) {
        case 0:
            newValue = '男';
            break;
        case 1:
            newValue = '女';
            break;
        default:
              newValue = '男';
    }
    return newValue;
});


/**
 * @birthday 出生日期
 * @return 周岁数
 */
Vue.filter('getAgeByBirthday', (birthday) => {
    var returnAge;
    var strBirthdayArr = birthday.split("-");
    var birthYear = strBirthdayArr[0];
    var birthMonth = strBirthdayArr[1];
    var birthDay = strBirthdayArr[2];

    var d = new Date();
    var nowYear = d.getFullYear();
    var nowMonth = d.getMonth() + 1;
    var nowDay = d.getDate();

    if (nowYear == birthYear) {
        returnAge = 0; //同年 则为0岁
    } else {
        var ageDiff = nowYear - birthYear;
        if (ageDiff > 0) {
            if (nowMonth == birthMonth) {
                var dayDiff = nowDay - birthDay; //日之差
                if (dayDiff < 0) {
                    returnAge = ageDiff - 1;
                } else {
                    returnAge = ageDiff;
                }
            } else {
                var monthDiff = nowMonth - birthMonth; //月之差
                if (monthDiff < 0) {
                    returnAge = ageDiff - 1;
                } else {
                    returnAge = ageDiff;
                }
            }
        } else {
            returnAge = -1; //返回-1 表示出生日期输入错误 晚于今天
        }
    }
    return returnAge; //返回周岁年龄
})


// WEBPACK FOOTER //
// ./src/utils/filter.js